import Repository from './Repository'

export default {
  getTeam() {
    return Repository.private().get(`/full-team`)
  },
  getAvgByStates(filters) {
    return Repository.private().get(`/stats/common/avg-by-states?${filters}`)
  },
  getAvgByEndStates(filters) {
    return Repository.private().get(`/stats/common/avg-by-end-states?${filters}`)
  },
  getAvgByMiddleStates(filters) {
    return Repository.private().get(`/stats/common/avg-by-middle-states?${filters}`)
  },
  getAvgByLPEndStates(filters) {
    return Repository.private().get(`/stats/common/avg-by-lp-end-states?${filters}`)
  },
  getAvgByLPMiddleStates(filters) {
    return Repository.private().get(`/stats/common/avg-by-lp-middle-states?${filters}`)
  },
  getAvgByPremium(filters) {
    return Repository.private().get(`/stats/common/avg-by-lp-end-states-premium?${filters}`)
  },
  getAvgQuotationLifeTime(filters) {
    return Repository.private().get(`/stats/common/avg-quotation-lifetime?${filters}`)
  },
  getAvgQuotationLifeTimePerArea(filters) {
    return Repository.private().get(`/stats/common/avg-quotation-lifetime-per-area?${filters}`)
  },
  getAvgObsPerArea(filters) {
    return Repository.private().get(`/stats/common/avg-obs-per-area?${filters}`)
  }
}
